type Name = 'safety-box';

export default function useFeatureFlag(name: Name, activeVariant = 'test') {
  const { $posthog } = useNuxtApp();
  const active = ref(false);

  onMounted(() => {
    active.value = $posthog.getFeatureFlag(name) == activeVariant;
  });

  return active;
}